import type { MqttClient } from "mqtt";

export const connections = new Map<string, MqttClient>();
export const connectionListenersInitialized = new Set<string>();
